import styles from './new_event.module.sass'

import classNames from 'classnames'
import each from 'lodash/each'

import library from '../library'

import Image from '../basic/image'
import BlockWrapper from '../layout/block_wrapper'
import Button from '../basic/button'
import Form from '../form'
import JuicerEmbed from '../juicer_embed'

function NewEvent(props) {
	let fields = props.fields || {}
	let formattedDate
	let tags = []

	if(fields.details?.conference?.name){
		tags.push(fields.details.conference.name)
	}

	if(fields.presentation_type?.name){
		tags.push(fields.presentation_type.name)
	} else {
		tags.push('Event')
	}

	if(fields.details?.cancer_type?.[0]?.name){
		tags.push(fields.details.cancer_type[0].name)
	}

	if(fields.details?.partner_study?.[0]?.name){
		tags.push(fields.details.partner_study[0].name)
	}

	if(fields.details?.product?.[0]?.name){
		tags.push(fields.details.product[0].name)
	}

	if (fields.details?.start_date) {
		if(fields.details.start_date && fields.details.end_date) {
			let formattedStartDate = new Date(fields.details.start_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric' })
			let formattedEndDate = new Date(fields.details.end_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
			formattedDate = `${formattedStartDate} - ${formattedEndDate}`
		} else {
			formattedDate = new Date(fields.details.start_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
		}
	}

	return <BlockWrapper {...props} className={classNames(styles.event)}>
		
		{fields.header_image?.image &&
			<div className={styles.header_image_wrapper}>
				<Image className={styles.header_image} fields={fields.header_image} />
				{fields.event_logo?.image &&
					<div className={styles.event_logo_wrapper}>
						<Image className={styles.event_logo} fields={fields.event_logo} />
					</div>
				}
			</div>
		}
		<div className={styles.event_intro_wrapper}>
			<div className={styles.event_intro_content}>
				<div className={styles.meta}>
					<p className={styles.date}>{formattedDate} | EVENTS</p>
				</div>
				<h1>{fields.title || ''}</h1>
				<p className={styles.location}>{fields.intro?.location || ''}</p>
				<div className={styles.event_intro_content_text} dangerouslySetInnerHTML={{__html: fields.intro?.description || ''}} />
				{fields.intro?.call_to_action?.url && <Button fields={fields.intro.call_to_action} className={styles.event_cta}></Button>}

				{fields.about_section?.section_heading && fields.about_section?.content &&
					<div className={styles.about_wrapper}>
						<div className={styles.about_content}>
							<h2>{fields.about_section.section_heading}</h2>
							<div dangerouslySetInnerHTML={{__html: fields.about_section.content}}></div>
						</div>
					</div>
				}
			</div>
			<div className={styles.event_intro_form}>
				{ fields?.intro?.form?.form &&
					<>
						<p className={styles.form_title}>{fields?.intro?.form?.title}</p>
						<Form fields={fields?.intro?.form.form}/>
					</>
				}
			</div>
		</div>

		{(fields.presentations_section?.section_heading || fields.presentations_section?.presentations?.length > 0) &&
			<div className={styles.presentations_wrapper}>
				{fields.presentations_section.section_heading && <h2>{fields.presentations_section.section_heading}</h2>}
				{fields.presentations_section.presentations.length > 0 && <div className={styles.presentations_list}>
					{fields.presentations_section.presentations.map((presentation, index) => {
						// Build tags for this presentation
						let presentationTags = []
						
						if(presentation.fields?.details?.conference?.name){
							presentationTags.push(presentation.fields.details.conference.name)
						}

						if(presentation.fields?.details?.date){
							presentationTags.push(new Date(presentation.fields.details.date).toLocaleDateString('en-US', {timeZone:"UTC", year:"numeric"}))
						}

						if(presentation.fields?.presentation_type?.name){
							presentationTags.push(presentation.fields.presentation_type.name)
						} else {
							presentationTags.push('Event')
						}

						if(presentation.fields?.details?.cancer_type?.[0]?.name){
							presentationTags.push(presentation.fields.details.cancer_type[0].name)
						}

						if(presentation.fields?.details?.partner_study?.[0]?.name){
							presentationTags.push(presentation.fields.details.partner_study[0].name)
						}

						if(presentation.fields?.details?.product?.[0]?.name){
							presentationTags.push(presentation.fields.details.product[0].name)
						}

						return (
							<div className={styles.presentation} key={index}>
								<div className={styles.presentation_description}>
									<div className={styles.presentation_type_icon}>
										{presentation.fields?.presentation_type?.name && 
											<img src={`/wp-content/themes/personalis/assets/resources/${presentation.fields.presentation_type.name.toLowerCase()}.svg`} alt={presentation.fields.presentation_type.name.toLowerCase()} className={styles.placeholder} />
										}
									</div>
									<div className={styles.presentation_content}>
										<h5 className={styles.presentation_meta}>
											{presentation.fields.details?.date && 
												<span className={styles.date}>{new Date(presentation.fields.details.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</span>
											}
											{presentation.fields.presentation_type && 
												<>
													{presentation.fields.details?.date && ' | '}
													<span className={styles.category}>{presentation.fields.presentation_type.name}</span>
												</>
											}
										</h5>
										<h3>
											{presentation.fields?.abstract_number && 
												<span className={styles.abstract_number}>[{presentation.fields.abstract_number}]</span>
											} 
											{presentation.post_title || ''}
										</h3>
										{presentation.fields.details?.location && presentation.fields.details?.time && 
											<h4>{presentation.fields.details.location}, {presentation.fields.details.time}</h4>
										}
										
										{/* Excerpt/Description */}
										{(presentation.fields?.excerpt || presentation.fields?.meta_description || presentation.fields?.content) && 
											<p>{presentation.fields.excerpt || presentation.fields.meta_description || presentation.fields.content}</p>
										}
										
										{/* Expandable content section */}
										<div className={styles.read_more_wrapper} style={{height: '0px', overflow: 'hidden'}}>
											<div className={styles.read_more_contents}>
												{presentation.fields?.read_more?.content && 
													<div className={styles.content} dangerouslySetInnerHTML={{__html: presentation.fields.read_more.content}}></div>
												}
												{presentation.fields?.read_more?.track && 
													<div className={styles.track}><strong>Track:</strong> {presentation.fields.read_more.track}</div>
												}
												{presentation.fields?.read_more?.lead_authors && 
													<div className={styles.authors}><strong>Lead/Authors:</strong> {presentation.fields.read_more.lead_authors}</div>
												}
												{presentation.fields?.read_more?.presenters && 
													<div className={styles.presenters}>
														{presentation.fields.read_more.presenters.map((presenter, presenterIndex) => 
															<div className={styles.presenter} key={presenterIndex}>
																<div className={styles.presenter_image}>
																	{presenter?.image?.sizes?.medium_large && 
																		<img src={presenter.image.sizes.medium_large} width={presenter.image.sizes['medium_large-width']} height={presenter.image.sizes['medium_large-height']} />
																	}
																</div>
																<div className={styles.presenter_content}>
																	<div className={styles.presenter_name}>{presenter?.name || ''}</div>
																	<div className={styles.presenter_title}>{presenter?.title || ''}</div>
																	<div className={styles.presenter_bio} dangerouslySetInnerHTML={{__html: presenter?.bio || ''}}></div>
																</div>
															</div>
														)}
													</div>
												}
											</div>
										</div>
										
										{/* Tags */}
										{presentationTags.length > 0 && 
											<div className={styles.tags_wrapper}>
												<div className={styles.tags_list}>
													{presentationTags.map((tag, tagIndex) => (
														<span className={styles.tag} key={tagIndex}>{tag}</span>
													))}
												</div>
											</div>
										}
										
										<div className={styles.presentation_link}>
											<span 
												className={styles.read_more_link}
												onClick={(e) => {
													const wrapper = e.target.closest(`.${styles.presentation}`).querySelector(`.${styles.read_more_wrapper}`);
													if (wrapper) {
														const isExpanded = wrapper.style.height !== '0px';
														wrapper.style.height = isExpanded ? '0px' : wrapper.scrollHeight + 'px';
														e.target.textContent = isExpanded ? 'Read More' : 'Read Less';
													}
												}}
											>
												Read More
											</span>
											{presentation.fields?.button?.url && 
												<a 
													href={presentation.fields.button.url}
													target={presentation.fields.button.target || '_self'}
													className={styles.call_to_action_link}
												>
													{presentation.fields.button.title || 'Learn More'}
												</a>
											}
										</div>
									</div>
								</div>
							</div>
						);
					})}
				</div>}
			</div>
		}

		{(fields.speakers_section?.section_heading || fields.speakers_section?.speakers?.length > 0) &&
			<div className={styles.speakers_wrapper}>
				{fields.speakers_section?.section_heading && <h2>{fields.speakers_section.section_heading}</h2>}
				{fields.speakers_section?.speakers?.length > 0 && <div className={styles.speakers_list}>
					{fields.speakers_section?.speakers?.map((speaker, index) => (
						<div className={styles.speaker} key={index}>
							<div className={styles.speaker_image_wrapper}>
								{speaker?.image && <Image className={styles.speaker_image} {...speaker.image} />}
							</div>
							<div className={styles.speaker_content}>
								<p className={styles.speaker_name}>{speaker?.name || ''}</p>
								<p className={styles.speaker_bio}>{speaker?.bio || ''}</p>
							</div>
						</div>
					))}
				</div>}
			</div>
		}
		
		{(fields.registration_section?.section_heading || fields.registration_section?.registration?.length > 0) &&
			<div className={styles.registration_wrapper}>
				{fields.registration_section.section_heading && <h2>{fields.registration_section.section_heading}</h2>}
				{fields.registration_section.registration.length > 0 && <div className={styles.registration_list}>
					{fields.registration_section?.registration?.length > 0 &&
						fields.registration_section.registration.map((registration, index) => (
							<div className={styles.registration} key={index}>
								<p className={styles.registration_heading}>{registration?.heading || ''}</p>
								<p>{registration?.description || ''}</p>
								{registration?.button &&
									<div className={styles.registration_button_wrapper}>
										<Button fields={registration.button}></Button>
									</div>
								}
							</div>
						))
					}
				</div>}
			</div>
		}

		{fields.social_section?.section_heading && fields.social_section?.juicer_embed_id &&
			<div className={styles.social_wrapper}>
				{fields.social_section.section_heading && <h2>{fields.social_section.section_heading}</h2>}
				{fields.social_section.juicer_embed_id && <JuicerEmbed fields={{embed_id: fields.social_section.juicer_embed_id}} />}
			</div>
		}

		{tags && tags.length > 0 &&
			<div className={styles.tags_wrapper}>
				<h2>Tags</h2>
				<div className={styles.tags_list}>
					{tags.map((tag, index) => (
						<span className={styles.tag} key={index}>{tag}</span>
					))}
				</div>
			</div>
		}
		
	</BlockWrapper>
}

export default NewEvent